<template>
  <div class="app">
    <v-card class="scrollable">
      <v-container fluid grid-list-lg>
        <div v-bind="text" class="font-weight-thin title">
          Ques: {{ text.question }}
        </div>
        <v-layout row>
          <v-flex xs5>
            <v-card-title class="title">Table of Answer (Range)</v-card-title>
            <v-data-table
              :headers="headers"
              :items="data"
              hide-actions
              :expand="true"
              :disable-initial-sort="true"
              class="elevation-1"
              dark
            >
              <template v-slot:items="props">
                <td>{{ props.item.si }}</td>
                <td>{{ props.item.max }}</td>
                <td>{{ props.item.min }}</td>
                <td>{{ props.item.range }}</td>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs7>
            <!-- <v-card-title class="title">Range Scatter Plot</v-card-title> -->
            <highcharts
              class="hc"
              :options="chartOptions"
              ref="chart"
            ></highcharts>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>
<script>
  import { Chart } from "highcharts-vue";
  import { mapGetters } from "vuex";

  export default {
    props: ["dataset"],
    components: {
      highcharts: Chart,
    },
    data: () => ({
      headers: [
        { text: "SI", value: "si", class: "title success white--text" },
        { text: "Max", value: "max", class: "title success white--text" },
        { text: "Min", value: "min", class: "title success white--text" },
        { text: "Range", value: "range", class: "title success white--text" },
      ],
      data: [
        {
          si: 1,
          max: 5,
          min: 1,
          range: 5 - 1,
        },
        {
          si: 2,
          max: 2,
          min: 1,
          range: 2 - 1,
        },
        {
          si: 3,
          max: 4,
          min: 3,
          range: 4 - 3,
        },
        {
          si: 4,
          max: 3,
          min: 2,
          range: 3 - 2,
        },
        {
          si: 5,
          max: 3,
          min: 2,
          range: 3 - 2,
        },
      ],
      text: {
        question: null,
      },
      chartOptions: {
        chart: {
          type: "scatter",
        },

        title: {
          text: "Scatter plot with jitter",
        },
        // subtitle: {
        //     text: 'Spread discrete values by randomizing the rendered position'
        // },
        xAxis: {
          categories: ["Min", "Max"],
        },
        yAxis: {
          title: {
            text: "Measurements",
          },
        },
        plotOptions: {
          scatter: {
            showInLegend: false,
            jitter: {
              x: 0.04,
              y: 0,
            },
            marker: {
              radius: 2,
              symbol: "circle",
            },
            tooltip: {
              pointFormat: "Value: {point.y:.3f}",
            },
          },
        },
        series: [
          {
            name: "Min",
            data: [
              [0, 1],
              [0, 1],
              [0, 3],
              [0, 2],
              [0, 2],
            ],
          },
          {
            name: "Max",
            data: [
              [1, 2],
              [1, 3],
              [1, 3],
              [1, 4],
              [1, 5],
            ],
          },
        ],
      },
    }),
    watch: {
      dataset: function () {
        this.getTestData();
      },
    },
    created() {
      this.getTestData();
    },
    methods: {
      getTestData() {
        this.chartOptions.series = this.dataset.graphData.series;
        this.data = this.dataset.graphData.tblData;
        this.text.question = this.dataset.queSet.question;
        //   for (let index = 0; index < 2; index++) {
        //     var data = [],
        //       off = 0.2 + 0.2 * Math.random(),
        //       i;
        //     for (i = 0; i < 200; i++) {
        //         data.push([index, off + (Math.random() - 0.5) * (Math.random() - 0.5)]);
        //     }
        //     this.chartOptions.series[index].data=data;
        //     // this.data.question = this.dataset.queSet.question
        //     console.log(this.chartOptions.series)

        //   }
      },
    },
  };
</script>
<style scoped>
  .scrollable {
    height: 500px; /* or any height you want */
    overflow-y: auto;
  }
</style>
